const isSlateInventoryType = (inventoryType?: string | null): boolean =>
  inventoryType?.toLowerCase() === 'slate';

export { isSlateInventoryType };
